"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_router_dom_1 = require("react-router-dom");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var NavBar_1 = require("stremio/components/NavBar");
var GamepadNavigation_1 = require("stremio/services/GamepadNavigation");
var MainNavBars_less_1 = __importDefault(require("./MainNavBars.less"));
var TABS = [
    { id: 'board', label: 'Board', icon: 'home', href: '/' },
    { id: 'discover', label: 'Discover', icon: 'discover', href: '/discover' },
    { id: 'library', label: 'Library', icon: 'library', href: '/library' },
    { id: 'calendar', label: 'Calendar', icon: 'calendar', href: '/calendar' },
    { id: 'addons', label: 'ADDONS', icon: 'addons', href: '/addons' },
    { id: 'settings', label: 'SETTINGS', icon: 'settings', href: '/settings' },
];
var MainNavBars = (0, react_1.memo)(function (_a) {
    var className = _a.className, route = _a.route, query = _a.query, children = _a.children;
    var navRef = react_1.default.useRef(null);
    var contentRef = react_1.default.useRef(null);
    var navRoute = route === 'continue_watching' ? 'library' : (route !== null && route !== void 0 ? route : '');
    (0, GamepadNavigation_1.useContentGamepadNavigation)(contentRef, navRoute);
    (0, GamepadNavigation_1.useVerticalNavGamepadNavigation)(navRef, navRoute);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, MainNavBars_less_1.default['main-nav-bars-container']) },
        react_1.default.createElement(NavBar_1.HorizontalNavBar, { className: MainNavBars_less_1.default['horizontal-nav-bar'], route: route, query: query, backButton: false, searchBar: true, fullscreenButton: true, navMenu: true }),
        react_1.default.createElement(NavBar_1.VerticalNavBar, { ref: navRef, className: MainNavBars_less_1.default['vertical-nav-bar'], selected: route, tabs: TABS }),
        react_1.default.createElement("nav", { className: MainNavBars_less_1.default['mobile-nav-bar'], "aria-label": "Primary navigation" }, [
            { id: 'board', label: 'Home', icon: 'home', href: '/' },
            { id: 'discover', label: 'Browse', icon: 'discover', href: '/discover' },
            { id: 'library', label: 'Library', icon: 'library', href: '/library' },
            { id: 'search', label: 'Search', icon: 'search', href: '/search' },
        ].map(function (tab) {
            var _a;
            return (react_1.default.createElement(react_router_dom_1.Link, { key: tab.id, to: tab.href, className: (0, classnames_1.default)(MainNavBars_less_1.default['mobile-nav-item'], (_a = {}, _a[MainNavBars_less_1.default['selected']] = route === tab.id || (route === 'continue_watching' && tab.id === 'library'), _a)), "aria-current": route === tab.id ? 'page' : undefined },
                react_1.default.createElement(react_2.default, { className: MainNavBars_less_1.default['mobile-nav-icon'], name: tab.icon }),
                react_1.default.createElement("span", null, tab.label)));
        })),
        react_1.default.createElement("div", { ref: contentRef, className: MainNavBars_less_1.default['nav-content-container'] }, children)));
});
exports.default = MainNavBars;
